// extracted by mini-css-extract-plugin
export default {"wrap":"uF-z","fullWidth":"vF-z","hideOnDesktop":"wF-z","content":"xF-z","hasOpenedNav":"yF-z","crumbsList":"zF-z","dropdownsWrap":"AF-z"};